export default __webpack_public_path__ + "static/media/help6.cf84ca9b.png";